import { apiFetch } from './apiFetch';
import type { EmbedLoginResponse, SessionUser } from '@deposits/shared';

export async function embedLogin(accessToken: string): Promise<EmbedLoginResponse> {
  return apiFetch<EmbedLoginResponse>('/auth/embed-login', {
    method: 'POST',
    body: JSON.stringify({ accessToken }),
  });
}

export interface MeResponse {
  user: SessionUser;
  settings: { box_id: number; default_depositor_user_boxes_id: number | null } | null;
  /** Whether this user's Arbox role may see the safe (כספת) tabs. */
  can_view_safe: boolean;
}

export async function fetchMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/me');
}
